import { GrIconButton, GrIconButtonProps, GrIconType, GrStack, GrTooltip, GrTooltipProps } from "@jnpmedi/grebob";

export type IconTooltipButtonProps = {
  iconType: GrIconType;
  tooltipContent: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  isActive?: boolean;
  tooltipProps?: Omit<GrTooltipProps, "content">;
  iconButtonProps?: Omit<GrIconButtonProps, "iconType" | "onClick" | "isActive">;
};

export function IconTooltipButton({ iconType, tooltipContent, onClick, isActive, tooltipProps, iconButtonProps }: IconTooltipButtonProps) {
  return (
    <GrTooltip
      {...tooltipProps}
      style={{ marginBottom: "6px !important", ...tooltipProps?.style }}
      content={tooltipContent}
      size={tooltipProps?.size || "small"}
      variant={tooltipProps?.variant || "plain"}
      arrow={tooltipProps?.arrow || false}
      placement={tooltipProps?.placement || "top"}
    >
      <GrStack>
        <GrIconButton
          {...iconButtonProps}
          iconType={iconType}
          color={iconButtonProps?.color}
          size={iconButtonProps?.size || 16}
          onClick={onClick}
          isActive={isActive}
        />
      </GrStack>
    </GrTooltip>
  );
}
